import React, { useContext, useEffect, useRef, useMemo, useState, useCallback } from "react";
import { Link, useNavigate, useLocation   } from "react-router-dom";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import sidebarData from "./SidebarData";
import { AuthContext } from "../contexts/AuthContext";


const Sidebar = () => {
  const ref = useRef();
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(location.pathname);
  const [activeMenuId, setActiveMenu] = useState(null);
  const [formattedSideBarData, setFormattedSideBarData] = useState([]);

  const { userDetails } = useContext(AuthContext);
  const navigate = useNavigate();  

  const momisedUserDetails = useMemo(()=>{
          return userDetails
  },[userDetails]) 


useEffect(() => {
  const modules = momisedUserDetails?.modules;
  if (modules) {
    // Filter the sidebar data based on userDetails' modules
    const formattedData = sidebarData.filter((item) =>
      modules.some((module) => item.id === module.id)
    );
    setFormattedSideBarData(formattedData);
  }
}, [momisedUserDetails]);

  const toggleSubMenu = (id) => {
    
    if (activeMenuId === id) {
      setActiveMenu(null); // Close the menu if it's already open
    } else {
      setActiveMenu(id); // Open the selected menu
    }
  };

  useEffect(() => {
    new MetisMenu("#side-menu-item");
    ref.current.recalculate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activateParentDropdown = useCallback(item => {

    
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }
    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag
        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }
        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");
            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };





  const activeMenu = useCallback(() => {
    const pathName = location.pathname;
    const fullPath = pathName;

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu-item");
    const items = ul.getElementsByTagName("a");


    removeActivation(items);
    // console.log("ITEMS after",items);
  
    
    for (let i = 0; i < items.length; ++i) {   
      // if (activeMenuId == 11) {
      
      //   for (let j = 0; j < items.length; ++j) {
      //     if (items[j].classList.contains('active')) {
            
      //       items[j].classList.remove('active');
      //       break; // Exit loop after removing the active class
      //     }
      //     console.log("removed item", items);
      //   }
      //   // removeActivation(items);
      //   items[9].classList.add('active');
      // }
      
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [
    location.pathname,
    activateParentDropdown,
    activeMenuId
  ]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  // useEffect(() => {
  //   new MetisMenu("#side-menu-item");
  //   activeMenu();
  // }, [selectedItem,activeMenuId]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function signOut(event) {
    event.preventDefault();
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    navigate("/login");
  }

  // Function for handle selected li style
  const handleItemClick = (item) => {
    setSelectedItem(item.url);
  };
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <SimpleBar className="h-100" ref={ref}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu-item">
              {formattedSideBarData?.map((item, key) => (
                <React.Fragment key={key}>
                  {item.isMainMenu ? (
                    <li className="menu-title">{item.label}</li>
                  ) : (
                    <li
                      key={key}
                      className={` ${selectedItem === (item.url === '' ? true : item.url) ? "" : "sideBarLi"}`}
                      onClick={() => handleItemClick(item)}
                    >
                    <Link
                      to={item.url ? item.url : "#"}
                      className={item.issubMenubadge ? "" : "has-arrow "}
                      onClick={() => toggleSubMenu(item.id)}
                      style={{ display: 'block' }}
                    >
                      <i className={item.icon} style={{ marginRight: '5px' }}></i>
                      <span>{item.label}</span>
                    </Link>

                    {/* Sub item */}
                    {item.subItem && (
                      <ul
                        className={`sub-menu ${
                          activeMenuId === item.id ? 'mm-show' : 'mm-collapse'
                        }`}
                        style={{
                          display: activeMenuId === item.id ? 'block' : 'none',
                          height: activeMenuId === item.id ? 'auto' : '0px',
                        }}  
                      >
                        {item.subItem.map((subItem, subKey) => (
                          <li key={subKey}>
                            <Link
                              to={subItem.link}
                              className={subItem.subMenu ? 'has-arrow waves-effect' : ''}
                            >
                              {subItem.sublabel}
                            </Link>
                            {subItem.subMenu && (
                              <ul className="sub-menu" >
                                {subItem.subMenu.map((subSubItem, subSubKey) => (
                                  <li key={subSubKey} >
                                    <Link to="#">{subSubItem.title}</Link>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
       {/* {item.subItem && (
  <ul className={`sub-menu ${activeMenuId === item.id ? 'show' : ''}`}>
    {item.subItem.map((subItem, subKey) => (
      <li key={subKey}>
        <Link
          to={subItem.link}
          className={subItem.subMenu ? "has-arrow" : ""}
          onClick={() => subItem.subMenu && toggleSubMenu(item.id)}
        >
          {subItem.sublabel}
        </Link>
        
        {subItem.subMenu && (
          <ul className={`sub-menu ${activeMenuId === subItem.id ? 'show' : ''}`}>
            {subItem.subMenu.map((subSubItem, subSubKey) => (
              <li key={subSubKey}>
                <Link to={subSubItem.link || "#"}>{subSubItem.title}</Link>
              </li>
            ))}
          </ul>
        )}
      </li>
    ))}
  </ul>
      )} */}

                    </li>
                  )}
                </React.Fragment>
              ))}
              <li>
                <Link to="/#" onClick={signOut} className="dropdown-item">
                  <i className="ri-shut-down-line align-middle me-2 text-danger" />
                  <span>Logout</span>
                </Link>
              </li>
            </ul>
          </div>
        </SimpleBar>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;


// import { useState, useRef } from 'react';

// const MyComponent = ({ menuItems }) => {
//   const [activeMenuId, setActiveMenu] = useState(null);

//   const toggleSubMenu = (id) => {
//     if (activeMenuId === id) {
//       setActiveMenu(null); // Close the menu if it's already open
//     } else {
//       setActiveMenu(id); // Open the selected menu
//     }
//   };

//   return (
//     <ul>
//       {menuItems.map((item, index) => (
//         <li key={index}>
      
//         </li>
//       ))}
//     </ul>
//   );
// };
